import { useEffect, useRef, useState } from 'react';

/**
 * Tracks the live pixel width of the right (Agent Cart) pane via a
 * ResizeObserver. The transcript takeover overlay stops before this pane, so
 * its inline `right` offset is derived from this width and stays correct after
 * the panes are resized. Returns the ref to attach and the measured width.
 */
const useRightPaneWidth = () => {
  const rightPaneRef = useRef<HTMLDivElement>(null);
  const [rightPaneWidth, setRightPaneWidth] = useState<number>(360);

  useEffect(() => {
    const element = rightPaneRef.current;
    if (!element || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect.width;
      if (width) setRightPaneWidth(width);
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return { rightPaneRef, rightPaneWidth };
};

export default useRightPaneWidth;
